import classNames from 'classnames';
import { bool, elementType, number, shape, string } from 'prop-types';

import DailyRewardImage from '~/components/DailyRewardImage';

import useBooleanState from '~/hooks/useBooleanState';

import DailyRewardPopup from './DailyRewardPopup';

import style from './Tile.module.scss';

export default function Tile({
  lastClaimAt,
  dailyNotificationsEnabled,
  siteNotificationsEnabled,
  reward,
  index,
  popupGradient,
}) {
  const { image, title, active, collected, src } = reward || {};
  const [show, toggleShow] = useBooleanState();

  return (
    <>
      <div
        className={classNames(style.tile, {
          [style.notCollected]: !collected,
          [style.active]: active,
        })}
        onClick={reward ? toggleShow : null}
      >
        {reward && (
          <div className={style.imageWrapper}>
            <DailyRewardImage
              path={image}
              src={src}
              alt={title || ''}
              collected={collected}
              className={style.rewardImage}
            />
          </div>
        )}
        {!collected && <span className={style.index}>{index + 1}</span>}
      </div>
      {reward && (
        <DailyRewardPopup
          reward={reward}
          show={show}
          toggleShow={toggleShow}
          popupGradient={popupGradient}
          dailyNotificationsEnabled={dailyNotificationsEnabled}
          siteNotificationsEnabled={siteNotificationsEnabled}
          lastClaimAt={lastClaimAt}
        />
      )}
    </>
  );
}

Tile.propTypes = {
  TileSVG: elementType,
  reward: shape({
    image: string,
    src: string,
    title: string,
    active: bool,
    next: bool,
    collected: bool,
  }),
  lastClaimAt: string,
  dailyNotificationsEnabled: bool.isRequired,
  siteNotificationsEnabled: bool.isRequired,
  index: number.isRequired,
  popupGradient: string.isRequired,
};
